import { Constants } from "../../../../../../../utils/constants"
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals"
import { calc30DaysAgo } from "../../indicators/methods/callEndpoints"

const formatResultTabulatorEndpoint = (payload: ObjectGeneric) => {
    const { startDate, endDate } = calc30DaysAgo({
        end: payload?.to,
        start: payload?.from,
        format: Constants.dateEndpoint2
    })
    let filters: any = []


    if (payload?.from || payload?.to) {
        filters.push({
            "range": {
                [payload?.intervale?.value == '1w' ? 'fecha_inicio_semana' : 'fecha_inicio']: {
                    "gte": payload?.from ? startDate : null,
                    "lte": payload?.to ? endDate : null
                }
            }
        })
    }
    if (!!payload?.divisions?.length) {
        filters.push({
            terms: {
                division_id: (payload?.divisions as Item[])?.map(item => item.value),
            },
        })
    }

    if (payload?.zones?.length) {
        filters.push({
            terms: {
                zona_id: (payload?.zones as Item[])?.map(item => item.value),
            },
        })
    }

    if (!!payload?.units?.length) {
        filters.push({
            terms: {
                unidad_id: (payload?.units as Item[])?.map(item => item.value),
            },
        })
    }

    if (payload?.month?.length) {
        filters.push({
            terms: {
                mes: (payload?.month as Item[])?.map(item => item.value),
            },
        })
    }

    if (payload?.year) {
        filters.push({
            term: {
                year: payload?.year.value,
            },
        })
    }

    if (!!payload?.questionnaire?.length) {
        filters.push({
            terms: {
                cuestionario_id: (payload?.questionnaire as Item[])?.map(item => item.value),
            },
        })
    }

    const body = {
        size: 0,
        query: {
            bool: {
                filter: filters
            }
        },
        aggs: {
            divisiones: {
                terms: { field: 'division_id', size: 100 },
                aggs: {
                    nombre_division: {
                        top_hits: {
                            size: 1,
                            _source: ['division', 'semana', 'fecha']
                        }
                    },
                    zonas: {
                        terms: { field: 'zona_id', size: 100 },
                        aggs: {
                            nombre_zona: {
                                top_hits: {
                                    size: 1,
                                    _source: ['zona']
                                }
                            },
                            unidades: {
                                terms: { field: 'unidad_id', size: 100 },
                                aggs: {
                                    nombre_unidad: {
                                        top_hits: {
                                            size: 1,
                                            _source: ['unidad', 'semana', 'fecha']
                                        }
                                    },
                                    meses: {
                                        terms: { field: 'mes', size: 12, order: { _key: 'asc' } },
                                        aggs: {
                                            total: { value_count: { field: 'unidad_id' } },
                                            finalizados: {
                                                filter: { term: { finalizado: true } }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    return body
}


export { formatResultTabulatorEndpoint }